<template>
  <div>
    <div v-if="currencies.length > 1">
      <div class="form-group currency_exchange_form notranslate">
        <select
          id="currency"
          v-model="current"
          class="form-control currency"
          @change="updateCurrency()"
        >
          <option
            v-for="newCurrency in currencies"
            :key="newCurrency"
            :value="newCurrency"
          >
            {{ newCurrency }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>

<script>
import CartApi from '../../shared/cart/cart_api'
import CurrencyApi from './currency-api'

export default {
  props: ['chargeablecurrencies'],
  data() {
    return {
      currencies: [],
      current: 'USD',
      error_message: []
    }
  },
  watch: {
    chargeablecurrencies() {
      this.currencies = ['USD'].concat(this.chargeablecurrencies)
    }
  },

  created() {
    if (this.chargeablecurrencies == undefined) {
      // Use all currencies for Event Pages
      this.fetchCurrencies()
    } else {
      // Only use chargeableCurrencies for cart/order vues
      this.getCurrentCurrency()
      this.currencies = ['USD'].concat(this.chargeablecurrencies)
    }

    let divListener = CartApi.cartChangeElement()

    if (divListener) {
      divListener.addEventListener(CartApi.cartChangeEventName(), this.getCurrentCurrency)
    }
  },
  methods: {
    fetchCurrencies() {
      CurrencyApi.availableCurrencies().then(currencies => {
        this.currencies = currencies.currencies
        this.current = currencies.current_currency
        this.$emit('currency-emit', this.error_message, this.current, Number(currencies.rate))
      })
    },

    updateCurrency() {
      let applyCredit = false
      if(this.$store){ applyCredit = this.$store.state.checkout.applyCredit }
      CurrencyApi.updateOrderRates(this.current, applyCredit).then((currentRate) => {
        if (currentRate === 'rate not updated') {
          this.error_message.push('Curreny was not able to update')
          this.$emit('currency-emit', this.error_message)
          this.error_message = []
        }
      })
    },

    getCurrentCurrency() {
      CurrencyApi.getCurrentCurrency().then(order => {
        if (order.currency) {
          this.current = order.currency
          this.$emit('currency-emit', this.error_message, this.current, Number(order.rate))
        }
      })
    }
  }
}
</script>
